import UXCatLayout from './UXCatLayout';

export default UXCatLayout;
